<template>
    <div class="w-full h-[142vw] relative overflow-hidden">
        <!-- 1 -->
        <div class="w-full h-auto relative">
            <img src="../../assets/img/Desktop/FirestormArena/11.webp" alt=""
                class="pt-[15vw] w-[83vw] h-auto ml-[8.5vw]">
            <div class="absolute w-full h-[30vw] bg-gradient-to-b from-transparent via-[#171717] to-transparent top-0">
            </div>
            <div class="absolute w-full h-[30vw] bg-gradient-to-b from-transparent via-[#171717] to-transparent top-0">
            </div>

            <!-- left -->
            <img src="../../assets/img/Desktop/FirestormArena/Vector2.webp" alt=""
                class="h-[42.96875vw] absolute top-[19vw] left-[8.5vw]">
            <!-- right -->
            <img src="../../assets/img/Desktop/FirestormArena/Vector2.webp" alt=""
                class="h-[42.96875vw] absolute top-[19vw] right-[8.5vw] rotate-[180deg]">
            <!-- image in left 1-->
            <img src="../../assets/img/Desktop/FirestormArena/8.webp" alt=""
                class="w-[24vw] absolute top-[14vw] left-[12.3vw]">
            <!-- image in left 2-->
            <img src="../../assets/img/Desktop/FirestormArena/7.webp" alt=""
                class="w-[32.8125vw] absolute top-[33vw] left-[7.5vw]">
            <!-- text-left -->
            <p
                class="text-black font-inter text-[3.33vw] absolute top-[50vw] font-extrabold left-[5vw] rotate-[90deg] ">
                Malakor.</p>

            <!-- image in right 1-->
            <img src="../../assets/img/Desktop/FirestormArena/10.webp" alt=""
                class="w-[24vw] absolute top-[20vw] right-[7vw]">
            <!-- image in right 2-->
            <img src="../../assets/img/Desktop/FirestormArena/9.webp" alt=""
                class="w-[32.8125vw] absolute top-[30vw] right-[15.5vw]">
            <!-- text-right -->
            <p
                class="text-white font-inter text-[3.33vw] absolute top-[50vw] font-extrabold right-[5vw] rotate-[-90deg] ">
                Aerthos.</p>

            <div class="text-center absolute top-[32vw] left-[39vw] rotate-[-46deg]">
                <p class="text-white text-[3.83vw] font-emeritus text-center leading-[4.5vw]">
                    Firestorm <br /> Arena
                </p>
                <p class="text-white text-[0.83vw] font-league font-semibold leading-[1.5vw] mt-[1vw]">
                    Immerse yourself in epic battles, where every tactical decision<br /> changes the tide. Watch your
                    heroes showcase their skills and<br /> dominate the battlefield!
                </p>
            </div>
        </div>
        <!-- feedback -->
        <div class="w-full h-[46.875vw] relative flex justify-center">
            <!-- oval -->
            <div class="w-[46.875vw] h-[46.875vw] bg-[#FF4242] rounded-full blur-[20vw] absolute top-[2vw]"></div>
            <!-- container  -->
            <div class="w-[83vw] h-auto absolute top-[8.6vw] flex flex-row content-above overflow-hidden">
                <div ref="imageChallengeRef"
                    class="w-[83vw] shrink-0  h-auto flex flex-row space-x-[1vw] image-challegen  transition-transform duration-500 ease-in-out translate-x-0">
                    <div class="w-[27vw] h-[26vw] overflow-hidden">
                        <img src="../../assets/img/Desktop/FirestormArena/1.webp" alt="" class="w-[27vw]">
                    </div>
                    <div class="w-[27vw] h-[26vw] overflow-hidden">
                        <img src="../../assets/img/Desktop/FirestormArena/5.webp" alt="" class="w-[27vw]">
                    </div>
                    <div class="w-[27vw] h-[26vw] overflow-hidden">
                        <img src="../../assets/img/Desktop/FirestormArena/3.webp" alt="" class="w-[27vw]">
                    </div>
                </div>

                <div ref="imageAdventureRef"
                    class="w-[83vw] shrink-0 h-auto flex flex-row space-x-[1vw] image-adventure  transition-transform duration-500 ease-in-out translate-x-0">
                    <div class="w-[27vw] h-[26vw] overflow-hidden">
                        <img src="../../assets/img/Desktop/FirestormArena/2.webp" alt="" class="w-[27vw]">
                    </div>
                    <div class="w-[27vw] h-[26vw] overflow-hidden">
                        <img src="../../assets/img/Desktop/FirestormArena/6.webp" alt="" class="w-[27vw]">
                    </div>
                    <div class="w-[27vw] h-[26vw] overflow-hidden">
                        <img src="../../assets/img/Desktop/FirestormArena/4.webp" alt="" class="w-[27vw]">
                    </div>
                </div>
            </div>
        </div>

        <div class="absolute bottom-0 left-0 w-full h-[10vw] bg-gradient-to-t from-[#171717] to-transparent"></div>

        <!-- feedback -->
        <div class="w-full h-auto relative flex justify-center translate-y-[-8vw]">
            <img src="../../assets/img/Desktop/Challegen/Union.webp" alt="" class="w-[83vw]">

            <!-- text challenge -->
            <div ref="textChallengeRef"
                class="absolute top-[2vw] right-[13.2vw] flex flex-row text-challengen items-center opacity-1 transition-all duration-500 ease-in-out">
                <p class="text-white text-[3.83vw] font-emeritus mr-[1.5vw]">Challegen</p>
                <p class="text-[0.83vw] text-white font-league">Step into the endless Boss Stage series, where each
                    victory is just the beginning of the next <br />
                    challenge. Each boss possesses unique skills and strategies — only the strongest, wisely upgraded
                    <br />
                    team can advance further. How far will you go before needing to return to upgrade and rematch?
                </p>
            </div>

            <!-- text adventure -->
            <div ref="textAdventureRef"
                class="absolute top-[2vw] right-[13.2vw] flex flex-row text-adventure items-center opacity-0 transition-all duration-500 ease-in-out">
                <p class="text-white text-[3.83vw] font-emeritus mr-[1.5vw]">Adventure</p>
                <p class="text-[0.83vw] text-white font-league">Adventure takes you into harsh dungeons, where each
                    battle requires careful preparation of your<br />
                    team composition, strength and strategy. Smartly combining hero types, exploiting enemy<br />
                    weakness, and coordinating skills are the keys to overcoming the toughest challenges.
                </p>
            </div>

            <div class="w-[11.25vw] h-[5.5vw] absolute top-[2.5vw] left-[12vw] flex flex-col justify-between">
                <div ref="buttonChallengeRef" @click="handleChallengeClick"
                    class="button-challegen w-[11.25vw] h-[2.35vw] bg-[#171717] rounded-full flex flex-row px-[1.5vw] justify-between items-center transition-all duration-500 ease-in-out hover:cursor-pointer">
                    <p class="text-white font-league text-[1.05vw] font-bold">Challegen</p>
                    <img src="../../assets/img/Desktop/Challegen/arrow.webp" alt="" class="w-[1.25vw] h-[1.25vw]">
                </div>
                <div ref="buttonAdventureRef" @click="handleAdventureClick"
                    class="button-adventure w-[11.25vw] h-[2.35vw] rounded-full flex flex-row px-[1.5vw] justify-between items-center transition-all duration-500 ease-in-out hover:cursor-pointer">
                    <p class="text-white font-league text-[1.05vw] font-bold">Adventure</p>
                    <img src="../../assets/img/Desktop/Challegen/arrow.webp" alt="" class="w-[1.25vw] h-[1.25vw]">
                </div>
            </div>

            <!-- content feedback -->
            <div class="w-[78.23vw] h-[23.33vw] flex flex-col justify-between absolute top-[14.33vw]">
                <!-- row 1 -->
                <div class="w-[78.23vw] h-auto flex flex-row justify-between">
                    <!-- comment 1 -->
                    <div class="w-[23.23vw] flex flex-col">
                        <div class="w-[23.23vw] h-[2.4vw] bg-[#171717] rounded-full flex flex-row justify-between pl-[0.4vw] pr-[1vw]">
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[1.6vw] h-[1.6vw]">
                                <p class="font-league text-[1.05vw] text-white font-bold ml-[0.5vw]">LunaFox#8831</p>
                            </div>
                            <div class="flex flex-row items-center space-x-[0.2vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                            </div>
                        </div>
                        <p class="w-[23.23vw] font-league text-[0.83vw] text-[#171717] font-semibold mt-[1vw]">
                            "Lighting and boss fights are 🔥🔥🔥. Idk how an idle game got<br/> me this hooked tbh."
                        </p>
                    </div>

                    <!-- comment 2 -->
                    <div class="w-[23.23vw] flex flex-col">
                        <div class="w-[23.23vw] h-[2.4vw] bg-[#171717] rounded-full flex flex-row justify-between pl-[0.4vw] pr-[1vw]">
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[1.6vw] h-[1.6vw]">
                                <p class="font-league text-[1.05vw] text-white font-bold ml-[0.5vw]">IronClaw#1923</p>
                            </div>
                            <div class="flex flex-row items-center space-x-[0.2vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                            </div>
                        </div>
                        <p class="w-[23.23vw] font-league text-[0.83vw] text-[#171717] font-semibold mt-[1vw]">
                            "Adventure mode is like... brain fried 😵‍💫 one wrong comp and<br/>you're 100% wiped lmao."
                        </p>
                    </div>

                    <!-- comment 3 -->
                    <div class="w-[23.23vw] flex flex-col">
                        <div class="w-[23.23vw] h-[2.4vw] bg-[#171717] rounded-full flex flex-row justify-between pl-[0.4vw] pr-[1vw]">
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/Challegen/discord.webp" alt="" class="w-[1.6vw] h-[1.6vw]">
                                <p class="font-league text-[1.05vw] text-white font-bold ml-[0.5vw]">MysticBear#6654</p>
                            </div>
                            <div class="flex flex-row items-center space-x-[0.2vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                            </div>
                        </div>
                        <p class="w-[23.23vw] font-league text-[0.83vw] text-[#171717] font-semibold mt-[1vw]">
                            "Idle Glory got that cute fantasy vibe 🤩 but the gameplay’s<br/>actually kinda deep. Lvling up the squad is super gud lol."
                        </p>
                    </div>
                </div>

                <!-- row 2 -->
                <div class="w-[78.23vw] h-auto flex flex-row justify-between">
                    <!-- comment 1 -->
                    <div class="w-[23.23vw] flex flex-col">
                        <div class="w-[23.23vw] h-[2.4vw] bg-[#171717] rounded-full flex flex-row justify-between pl-[0.4vw] pr-[1vw]">
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/Challegen/reddit.webp" alt="" class="w-[1.6vw] h-[1.6vw]">
                                <p class="font-league text-[1.05vw] text-white font-bold ml-[0.5vw]">u/PixelPaladin</p>
                            </div>
                            <div class="flex flex-row items-center space-x-[0.2vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                            </div>
                        </div>
                        <p class="w-[23.23vw] font-league text-[0.83vw] text-[#171717] font-semibold mt-[1vw]">
                            "Fr tho, Idle Glory artstyle is hella charming 🔥 like, it's cute af<br/>but still feels kinda epic at the same time lol."
                        </p>
                    </div>

                    <!-- comment 2 -->
                    <div class="w-[23.23vw] flex flex-col">
                        <div class="w-[23.23vw] h-[2.4vw] bg-[#171717] rounded-full flex flex-row justify-between pl-[0.4vw] pr-[1vw]">
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/Challegen/reddit.webp" alt="" class="w-[1.6vw] h-[1.6vw]">
                                <p class="font-league text-[1.05vw] text-white font-bold ml-[0.5vw]">u/StrategicSloth</p>
                            </div>
                            <div class="flex flex-row items-center space-x-[0.2vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                            </div>
                        </div>
                        <p class="w-[23.23vw] font-league text-[0.83vw] text-[#171717] font-semibold mt-[1vw]">
                            "Finally an idle RPG where team synergy actually matters 🙌.<br/>Love messing around with diff hero comps tbh."
                        </p>
                    </div>

                    <!-- comment 3 -->
                    <div class="w-[23.23vw] flex flex-col">
                        <div class="w-[23.23vw] h-[2.4vw] bg-[#171717] rounded-full flex flex-row justify-between pl-[0.4vw] pr-[1vw]">
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/Challegen/reddit.webp" alt="" class="w-[1.6vw] h-[1.6vw]">
                                <p class="font-league text-[1.05vw] text-white font-bold ml-[0.5vw]">u/ManaGrind</p>
                            </div>
                            <div class="flex flex-row items-center space-x-[0.2vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                                <img src="../../assets/img/Desktop/Challegen/star.webp" alt="" class="w-[1vw] h-[1vw]">
                            </div>
                        </div>
                        <p class="w-[23.23vw] font-league text-[0.83vw] text-[#171717] font-semibold mt-[1vw]">
                            "The challenge stages hit diff 😭. You slam into that wall,<br/> upgrade your squad, and BOOM — so damn satisfying lmao."
                        </p>
                    </div>
                </div>

                <!-- Row 3 -->
                 <div class="w-[78.23vw] h-auto flex flex-row items-center">
                    <p class="font-emeritus text-[3.83vw] text-[#171717]">Feedback</p>
                    <p class="font-league text-[0.83vw] text-[#171717] ml-[2vw] font-semibold">We’ve already received great feedback from our early access community. Join Idle Glory today <br/>
                    and help build an epic gaming community together!
                    </p>
                 </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const buttonAdventureRef = ref(null);
const buttonChallengeRef = ref(null);
const textAdventureRef = ref(null);
const textChallengeRef = ref(null);
const imageChallengeRef = ref(null);
const imageAdventureRef = ref(null);

const bgActiveClass = 'bg-[#171717]';
const opacityVisibleClass = 'opacity-1';
const opacityHiddenClass = 'opacity-0';

const translateXZeroClass = 'translate-x-0';
const translateXNegativeFullClass = '-translate-x-full'; 

const handleAdventureClick = () => {
    if (buttonAdventureRef.value && buttonChallengeRef.value &&
        textAdventureRef.value && textChallengeRef.value &&
        imageChallengeRef.value && imageAdventureRef.value) {
        buttonAdventureRef.value.classList.add(bgActiveClass);
        buttonChallengeRef.value.classList.remove(bgActiveClass);
        textAdventureRef.value.classList.remove(opacityHiddenClass);
        textAdventureRef.value.classList.add(opacityVisibleClass);
        textChallengeRef.value.classList.remove(opacityVisibleClass);
        textChallengeRef.value.classList.add(opacityHiddenClass);
        imageChallengeRef.value.classList.remove(translateXZeroClass);
        imageChallengeRef.value.classList.add(translateXNegativeFullClass);
        imageAdventureRef.value.classList.remove(translateXZeroClass);
        imageAdventureRef.value.classList.add(translateXNegativeFullClass);
    }
};

const handleChallengeClick = () => {
    if (buttonAdventureRef.value && buttonChallengeRef.value &&
        textAdventureRef.value && textChallengeRef.value &&
        imageChallengeRef.value && imageAdventureRef.value) {
        buttonChallengeRef.value.classList.add(bgActiveClass);
        buttonAdventureRef.value.classList.remove(bgActiveClass);
        textChallengeRef.value.classList.remove(opacityHiddenClass);
        textChallengeRef.value.classList.add(opacityVisibleClass);
        textAdventureRef.value.classList.remove(opacityVisibleClass);
        textAdventureRef.value.classList.add(opacityHiddenClass);
        imageChallengeRef.value.classList.remove(translateXNegativeFullClass);
        imageChallengeRef.value.classList.add(translateXZeroClass);
        imageAdventureRef.value.classList.remove(translateXNegativeFullClass);
        imageAdventureRef.value.classList.add(translateXZeroClass);
    }
};
</script>


<style scoped>
.font-emeritus {
    font-family: "Emeritus", sans-serif;
}

.font-league {
    font-family: "LeagueSpartan", sans-serif;
}

.font-inter {
    font-family: "Inter", sans-serif;
}
</style>